import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import RefreshIcon from "@mui/icons-material/Refresh";
import ReplayIcon from "@mui/icons-material/Replay";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Box,
  Chip,
  CircularProgress,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { toast } from "react-toastify";
import { QA_BLOCKED_TOOLTIP } from "./constants";
import { formatDateTime, formatMoney, getStatusChipColor } from "./utils";

const SmsMonitoringTable = ({
  rows,
  totalCount,
  pageNumber,
  pageSize,
  loading,
  isAdmin,
  onPageChange,
  onViewDetail,
  onRefreshStatus,
  onRetry,
}) => {
  const handleCopy = (messageId) => {
    if (!messageId) return;
    navigator.clipboard?.writeText(String(messageId));
    toast.success("شناسه پیام کپی شد");
  };

  if (loading && !rows.length) {
    return (
      <Box sx={{ py: 6, textAlign: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!rows.length) {
    return (
      <Paper variant="outlined" sx={{ p: 4, textAlign: "center" }}>
        <Typography color="text.secondary">
          رکوردی یافت نشد. فیلترها را بازنشانی کنید یا پس از ارسال پیامک جدید دوباره جستجو کنید.
        </Typography>
      </Paper>
    );
  }

  return (
    <>
      <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 560 }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell>شناسه</TableCell>
              <TableCell>تاریخ ارسال</TableCell>
              <TableCell>گیرنده</TableCell>
              <TableCell>نوع پیامک</TableCell>
              <TableCell>هدف ارسال</TableCell>
              <TableCell>شناسه درخواست</TableCell>
              <TableCell>وضعیت داخلی</TableCell>
              <TableCell>وضعیت سرویس‌دهنده</TableCell>
              <TableCell>هزینه</TableCell>
              <TableCell>تلاش</TableCell>
              <TableCell>شناسه پیام</TableCell>
              <TableCell align="center">عملیات</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id} hover>
                <TableCell>{row.id}</TableCell>
                <TableCell>{formatDateTime(row.createDate)}</TableCell>
                <TableCell>{row.receptor}</TableCell>
                <TableCell>{row.monitoringCategoryLabel || row.smsType}</TableCell>
                <TableCell>{row.purpose || "—"}</TableCell>
                <TableCell>{row.referenceID || row.referenceId || row.requestId || "—"}</TableCell>
                <TableCell>
                  <Tooltip title={row.isQaBlocked ? QA_BLOCKED_TOOLTIP : ""}>
                    <Chip
                      size="small"
                      label={
                        row.isQaBlocked
                          ? "مسدود شده در حالت تست"
                          : row.internalStatusLabel || row.sendStatusTitle
                      }
                      color={getStatusChipColor(row.internalStatusKey, row.isQaBlocked)}
                    />
                  </Tooltip>
                </TableCell>
                <TableCell>{row.providerStatusLabel || "—"}</TableCell>
                <TableCell>{formatMoney(row.cost)}</TableCell>
                <TableCell>{row.attemptCount ?? 1}</TableCell>
                <TableCell>{row.messageId || row.messageid || "—"}</TableCell>
                <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                  <Tooltip title="مشاهده جزئیات">
                    <IconButton size="small" onClick={() => onViewDetail(row.id)}>
                      <VisibilityIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  {(row.messageId || row.messageid) > 0 ? (
                    <Tooltip title="بررسی وضعیت">
                      <IconButton size="small" onClick={() => onRefreshStatus(row.id)}>
                        <RefreshIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                  {isAdmin && row.canRetry ? (
                    <Tooltip title="ارسال مجدد">
                      <IconButton size="small" color="warning" onClick={() => onRetry(row.id)}>
                        <ReplayIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                  {(row.messageId || row.messageid) > 0 ? (
                    <Tooltip title="کپی شناسه پیام">
                      <IconButton
                        size="small"
                        onClick={() => handleCopy(row.messageId || row.messageid)}
                      >
                        <ContentCopyIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={totalCount}
        page={Math.max(0, pageNumber - 1)}
        onPageChange={(_, page) => onPageChange(page + 1)}
        rowsPerPage={pageSize}
        onRowsPerPageChange={(e) => onPageChange(1, parseInt(e.target.value, 10))}
        rowsPerPageOptions={[25, 50, 100]}
        labelRowsPerPage="تعداد در صفحه"
      />
    </>
  );
};

export default SmsMonitoringTable;
